<template>
    <Layout>
        <el-main style="flex: 1;">
            <div class="action-header">
                <el-radio-group
                    @change="changeBind"
                    style="margin-right: 20px;"
                    v-model="search.bind"
                >
                    <el-radio-button
                        :key="item.value"
                        :label="item.value"
                        name="device-tabs"
                        v-for="item in TABS"
                    >{{ item.label }}</el-radio-button>
                </el-radio-group>

                <el-button-group>
                    <el-button
                        :disabled="selection.length === 0"
                        @click="clickBind"
                        v-if="search.bind == TABS_UNBIND"
                    >分配给商户</el-button>
                    <el-button :disabled="selection.length === 0" @click="clickUnbind" v-else>解除绑定</el-button>
                    <el-button :disabled="selection.length === 0" @click="clickAuth">修改授权</el-button>
                </el-button-group>

                <el-input class="input" clearable placeholder="请输入关键字" v-model="key">
                    <i
                        @click="handleSearch"
                        class="el-input__icon el-icon-search btn-search"
                        slot="suffix"
                    />
                </el-input>
            </div>
            <Table :key="search.bind" />
            <Pagination />
        </el-main>
        <DialogDevice />
    </Layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
    TABS,
    TABS_UNBIND,
    DEVICE_BIND,
    DEVICE_AUTH,
} from '../../../libs/enum.js';
/** components */
import Layout from '../../main/layout';
import Table from './table';
import Pagination from './pagination';
import DialogDevice from './dialog.device';

const { mapState, mapActions } = createNamespacedHelpers('agentDevice');

export default {
    components: { Layout, Table, Pagination, DialogDevice },
    data() {
        return {
            TABS,
            TABS_UNBIND,
            key: '',
        };
    },
    computed: {
        ...mapState({
            search: (state) => state.search,
            selection: (state) => state.selection,
        }),
        agentId() {
            return this.$route.query.agentId;
        },
        agentName() {
            return this.$route.query.agentName;
        },
    },
    methods: {
        ...mapActions([
            'changeSearch',
            'changeDialog',
            'changeForm',
            'changeSelection',
            'changeMaxChannel',
            'getDevices',
            'unbindDevice',
        ]),
        changeBind(value) {
            this.changeSearch({
                bind: value,
                page: 1,
                agentId: value === this.TABS_UNBIND ? 0 : this.agentId,
            });
            this.changeSelection([]);
        },
        clickBind() {
            this.changeDialog({ visible: true, type: DEVICE_BIND });
            const deviceIds = this.selection
                .map((item) => item.deviceId)
                .join(',');
            this.changeForm({ deviceIds: deviceIds });
            const maxChannel = Math.min(
                ...this.selection.map((item) => item.maxChannel)
            );
            this.changeMaxChannel(maxChannel);
        },
        clickUnbind() {
            this.$confirm(
                `是否解除设备与 ${this.agentName} 商户的绑定？`,
                '解除绑定',
                { type: 'warning' }
            )
                .then(async () => {
                    const deviceIds = this.selection
                        .map((item) => item.deviceId)
                        .join(',');
                    await this.unbindDevice({ deviceIds });
                    this.$message.success('解除绑定成功');
                })
                .catch(() => {
                    this.$message.info('取消解除绑定');
                });
        },
        clickAuth() {
            this.changeDialog({ visible: true, type: DEVICE_AUTH });
            const deviceIds = this.selection
                .map((item) => item.deviceId)
                .join(',');
            this.changeForm({ deviceIds: deviceIds });
            const maxChannel = Math.min(
                ...this.selection.map((item) => item.maxChannel)
            );
            this.changeMaxChannel(maxChannel);
        },
        handleSearch() {
            this.changeSearch({ key: this.key, page: 1 });
        },
    },
    mounted() {
        this.getDevices();
    },
};
</script>

<style lang="less" scoped>
.action-header {
    margin-bottom: 20px;
    overflow: hidden;
    .input {
        float: right;
        width: 250px;
    }
    .btn-search {
        width: 30px;
        font-size: 18px;
        cursor: pointer;
        &:hover {
            color: #409eff;
        }
    }
}
</style>
